module.exports = __webpack_public_path__ + "static/img/loading.9aefe5b0.gif";